module.exports = __webpack_public_path__ + "img/2017.d2890438.png";